module.exports = __webpack_public_path__ + "img/hr-branch-particle-01.082e01d8.png";